import { StaticPaymentContent } from '@/api/Payment/payment.interfaces';
import { PassengerType } from '@/api/Checkout/checkout.interfaces';

export const fakeStaticPaymentContent: StaticPaymentContent = {
    BookingNumber: null,
    BookingPageUrl: '',
    GenderTitles: {
        1: 'Male',
        2: 'Female',
    },
    AgeRangeDefinitions: {
        Flight: {
            Adult: {
                Min: 12,
                Max: 120,
                Type: PassengerType.Adult,
            },
            Child: {
                Min: 2,
                Max: 11,
                Type: PassengerType.Child,
            },
            Infant: {
                Min: 0,
                Max: 1,
                Type: PassengerType.Infant,
            },
        },
        Ferry: {
            Adult: {
                Min: 16,
                Max: 120,
                Type: PassengerType.Adult,
            },
            Child: {
                Min: 4,
                Max: 15,
                Type: PassengerType.Child,
            },
            Infant: {
                Min: 0,
                Max: 3,
                Type: PassengerType.Infant,
            },
        },
    },
};
